import { useMemo } from "react"

import * as turf from "@turf/turf"
import { GeoJSONSourceSpecification, Source } from "react-map-gl/mapbox"

import { useMapStateContext } from "../../contexts/MapContext"

type UserLocationSourceProps = GeoJSONSourceSpecification & {
    id?: string;
    children?: React.ReactNode;
};

export function UserLocationSource(props: UserLocationSourceProps) {

    const {
        ...sourceProps
    } = props

    const { userLocation } = useMapStateContext()

    const data = useMemo(() => {
        if (userLocation) {
            const userPoint = turf.point([userLocation.longitude, userLocation.latitude])
            const collection = turf.featureCollection([userPoint])
            return collection
        }

        return null
    }, [userLocation])

    if (!userLocation) {
        return null
    }

    return (
        <Source {...sourceProps} type="geojson" data={data} tolerance={.001} />
    )
}
